import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {MatButtonModule} from '@angular/material/button';
import { RouterLink, RouterModule } from "@angular/router";

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.less'],
  imports: [FontAwesomeModule, MatButtonModule, RouterModule]
})
export class BackButtonComponent {
  faArrowLeft = faArrowLeft;
  @Input() color: string = 'black';

}
